/**
 * Auth Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress'
import AuthApi from '@/api/auth'
import router from '../../../router'
import storageUtil from '@/helpers/storage'
import _ from 'lodash'

const state = {
  user: storageUtil.getKey('user', true)
}

// getters
const getters = {
  getUser: state => state.user,
  getPermisos: state => (state.user ? state.user.permisos : []),
  tengoRolId: state => id => {
    if (state.user) {
      return (
        _.findIndex(state.user.roles, o => {
          return o.id === id
        }) > -1
      )
    }
    return false
  },
  tengoRolNombre: state => nombre => {
    if (state.user) {
      return (
        _.findIndex(state.user.roles, o => {
          return o.name === nombre
        }) > -1
      )
    }
    return false
  },
  asignadoAlCentroDelPaciente: state => paciente => {
    if (state.user && paciente) {
      /* return (
        _.findIndex(state.user.instituciones_ids, o => {
          return parseInt(o) === paciente.institucion_principal.institucion_id
        }) > -1
      ) */
      return true
    }
    return false
  },
  obtenerInstitucionAsignadaPorCodigo: state => codigo => {
    if (state.user) {
      return _.find(state.user.instituciones, { codigo: codigo })
    }
    return null
  }
}

// actions
const actions = {
  signupUserWithLaravelPassport (context, payload) {},
  login (context, payload) {
    const { user } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.login(user).then(
        data => {
          // setTimeout(() => {
          context.commit('loginUserSuccess', data.user)
          // }, 500)
        },
        error => {
          // setTimeout(() => {
          context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  },
  olvidePassword (context, payload) {
    const { credenciales } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.olvidePassword(credenciales).then(
        data => {
          setTimeout(() => {
            context.commit('olvidePasswordSuccessfully')
          }, 500)
        },
        error => {
          setTimeout(() => {
            context.commit('olvidePasswordFailure', error)
            reject(error)
          }, 500)
        }
      )
    })
  },
  cambiarPassword (context, payload) {
    const { credenciales } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.cambiarPassword(credenciales).then(
        data => {
          setTimeout(() => {
            context.commit('cambiarPasswordSuccessfully')
          }, 500)
        },
        error => {
          setTimeout(() => {
            context.commit('cambiarPasswordFailure', error)
            reject(error)
          }, 500)
        }
      )
    })
  },
  invalidEmail (context) {
    context.commit('invalidEmailSent')
  },
  logout (context) {
    Nprogress.start()
    AuthApi.logout().then(data => {
      context.commit('logoutUser')
    })
  },
  usuario (context) {
    return new Promise((resolve, reject) => {
      AuthApi.usuario().then(
        data => {
          context.commit('setearUsuario', data)
          resolve()
        },
        error => {
          reject(error)
        }
      )
    })
  },
  registrar (context, payload) {
    const { data } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.registrar(data).then(
        data => {
          // setTimeout(() => {
          context.commit('loginUserSuccess', data.user)
          // }, 500)
        },
        error => {
          // setTimeout(() => {
          context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  }
}

// mutations
const mutations = {
  setearUsuario (state, usuario) {
    state.user = usuario
    storageUtil.setKey('user', usuario)
  },
  setearInstituciones (state, payload) {
    state.user.instituciones = payload.instituciones
    state.user.instituciones_ids = payload.instituciones_ids
    storageUtil.setKey('user', state.user)
  },
  loginUserSuccess (state, user) {
    Nprogress.done()
    // state.user = user
    storageUtil.setKey('user', user)

    if (!_.find(user.roles, { name: 'Medico' }) && !_.find(user.roles, { name: 'Tecnico' }) && !_.find(user.roles, { name: 'Director Medico' })) {
      router.push({ name: 'dashboard' })
    } else {
      router.push({ name: 'acceso' })
    }
  },
  loginUserFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
    return error
  },
  logoutUser (state) {
    Nprogress.done()
    state.user = null
    storageUtil.removeKey('user')
    storageUtil.removeKey('auth_token')
    router.push({
      name: 'login'
    })
  },
  signUpUserSuccess (state, user) {
    state.user = localStorage.setItem('user', user)
    router.push('/dashboard')
    Vue.notify({
      group: 'general',
      type: 'success',
      text: 'Account Created!'
    })
  },
  signUpUserFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
  },
  olvidePasswordSuccessfully (state) {
    Nprogress.done()
    router.push({ name: 'login' })
    Vue.notify({
      group: 'general',
      type: 'success',
      text: 'Enviamos un email a tu casilla para recuperar el password.'
    })
  },
  olvidePasswordFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
  },
  cambiarPasswordSuccessfully (state) {
    Nprogress.done()

    router.push({ name: 'login' })

    Vue.notify({
      group: 'general',
      type: 'success',
      text: 'La operacion finalizo con exito'
    })
  },
  cambiarPasswordFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
  },
  setPermisos (state, payload) {
    state.user.permisos = payload.permisos
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
